let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b25oZ")).then(() => parcelRequire('fe43f'));